<template>
    <div class>
        <el-card shadow="never">
            <div slot="header">
                <span class="title">充电枪信息</span>
            </div>
            <el-form ref="firstForm" :model="firstForm" :rules="firstRules" label-width="120px">
                <div style="width: 600px">
                    <el-form-item label="归属电站" prop="station">
                        <div style="width: 100%">{{ station }}</div>
                    </el-form-item>
                    <el-form-item label="品牌型号" prop="equipmentBrandId">
                        <div style="width: 100%">{{ equipmentBrandId }}</div>
                    </el-form-item>
                    <el-form-item label="当前充电枪编码" prop="connectorCode">
                        <el-input v-model="firstForm.connectorCode" placeholder="请输入当前充电枪编码"
                            style="width: 100%"></el-input>
                        <span style="font-size: 13px; line-height: 20px; color: #409eff">
                            温馨提示：枪编码长度需保持16位，目前仅支持修改后两位！
                        </span>
                        <!-- <div style="width:100%;">{{ firstForm.connectorCode }}</div> -->
                    </el-form-item>
                    <el-form-item label="充电枪名称" prop="connectorName">
                        <el-input v-model="firstForm.connectorName" placeholder="请输入充电枪名称" style="width: 100%" />
                    </el-form-item>
                </div>
            </el-form>
        </el-card>

        <el-card shadow="never">
            <div slot="header">
                <span class="title">电桩信息</span>
            </div>
            <el-form ref="secondForm" :model="secondForm" :rules="secondRules" label-width="120px">
                <div style="width: 600px">
                    <el-form-item label="电桩编码" prop="equipmentCode">
                        <div>{{ secondForm.equipmentCode }}</div>
                    </el-form-item>
                    <el-form-item label="充电枪数量" prop="address">
                        <span>{{ number }}</span><br />
                        <span style="font-size: 13px; line-height: 20px; color: #409eff">
                            温馨提示：多枪电桩型号会自动生成多个终端，在桩编码、桩名称后添加后缀-01、-02...-N，从而生成相应终端的编码、名称。
                        </span>
                    </el-form-item>
                    <el-form-item label="协议版本" prop="agreementVersion">
                        <el-select v-model="secondForm.agreementVersion" placeholder="请选择协议版本" style="width: 100%">
                            <el-option label="直连" :value="0" />
                            <el-option label="其他" :value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="通讯模块类别" prop="communicationType">
                        <el-select v-model="secondForm.communicationType" placeholder="请选择通讯模块类别" style="width: 67.5%">
                            <el-option label="联通、移动2G" :value="0" />
                            <el-option label="联通、移动2G3G" :value="1" />
                            <el-option label="联通、移动、电信2G3G4G" :value="2" />
                            <el-option label="联通、移动、电信2G3G" :value="3" />
                            <el-option label="联通、移动2G3G4G" :value="4" />
                            <el-option label="联通、移动2G3G4G 电信" :value="5" />
                            <el-option label="联通、移动2G3G 电信 2" :value="6" />
                            <el-option label="联通、移动、电信2G" :value="7" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="通讯运营商" prop="communicationOperator">
                        <el-radio-group v-model="secondForm.communicationOperator" style="width: 100%">
                            <el-radio label="电信" />
                            <el-radio label="移动" />
                            <el-radio label="联通" />
                            <el-radio label="未知" />
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="功率" prop="power">
                        <el-input v-model="secondForm.power" placeholder="请输入功率" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="有无SIM" prop="hasSIM">
                        <el-radio-group v-model="secondForm.hasSIM" style="width: 100%" @change="isHasSIM">
                            <el-radio :label="false">无</el-radio>
                            <el-radio :label="true">有</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="isSIM" label="SIM卡号" prop="SIMNum">
                        <el-input v-model="secondForm.SIMNum" placeholder="请输入SIM卡号" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="车位号" prop="parkNo">
                        <el-input v-model="secondForm.parkNo" placeholder="请输入车位号" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="有无地锁" prop="parkLock">
                        <el-radio-group v-model="secondForm.parkLock" style="width: 100%">
                            <el-radio :label="false">无</el-radio>
                            <el-radio :label="true">有</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </el-form>
        </el-card>

        <el-card shadow="never">
            <div slot="header">
                <span class="title">运营信息</span>
            </div>
            <el-form ref="editForm" :model="editForm" label-width="120px">
                <el-form-item label="价格设置" prop="planLocation">
                    <el-radio-group v-model="editForm.planLocation" @change="selectplanLocation">
                        <el-radio :label="0">按电站定价</el-radio>
                        <el-radio :label="1">单独定价</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="isPrice" style="margin-bottom: 20px">
                    <el-row v-for="(item, index) in editForm.types" :key="index">
                        <div style="display: flex; justify-content: space-between">
                            <el-form-item :label="index === 0 ? '价格类别' : ''" prop="code" style="width: 120px" />
                            <el-form-item label="类别名称" :prop="'types.' + index + '.name'" :rules="editFormRules.name"
                                style="width: calc(33% - 40px)">
                                <el-input v-model="item.name" placeholder="请输入类别名称" style="width: 100%"
                                    @input="addPriceTypeClick()" />
                            </el-form-item>
                            <el-form-item label="电费" :prop="'types.' + index + '.elecMoney'"
                                :rules="editFormRules.elecMoney" style="width: calc(33% - 40px)">
                                <el-input v-model="item.elecMoney" style="width: 100%" type="number"
                                    placeholder="请输入电费单价" @input="addPriceTypeClick()"
                                    @blur="changeElecMoney(item.elecMoney)">
                                    <template slot="append">元/度</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="服务费" :prop="'types.' + index + '.serviceMoney'"
                                :rules="editFormRules.serviceMoney" style="width: calc(33% - 40px)">
                                <el-input v-model="item.serviceMoney" style="width: 100%" type="number"
                                    placeholder="请输入服务费单价" @input="addPriceTypeClick()"
                                    @blur="changeServiceMoney(item.serviceMoney)">
                                    <template slot="append">元/度</template>
                                </el-input>
                            </el-form-item>
                        </div>
                    </el-row>
                    <div v-if="editForm.types.length > 1 && editForm.ranges.length > 0">
                        <el-row v-for="(item, index) in editForm.ranges" :key="index">
                            <div style="display: flex; justify-content: space-between">
                                <el-form-item :label="index === 0 ? '价格设置' : ''" prop="name" style="width: 120px" />
                                <el-form-item label="开始时间" :prop="'ranges.' + index + '.priceStartPeriod'"
                                    :rules="editFormRules.priceStartPeriod" style="width: calc(33% - 40px)">
                                    <el-select v-model="item.priceStartPeriod" placeholder="请选择开始时间" style="width: 100%"
                                        @focus="selectFocusTime(1, index, item)">
                                        <el-option v-for="item in startTimeList" :key="item.value" :label="item.label"
                                            :value="item.value" :disabled="item.disabled" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="结束时间" :prop="'ranges.' + index + '.priceEndPeriod'"
                                    :rules="editFormRules.priceEndPeriod" style="width: calc(33% - 40px)">
                                    <el-select v-model="item.priceEndPeriod" placeholder="请选择结束时间" style="width: 100%"
                                        @focus="selectFocusTime(2, index, item)">
                                        <el-option v-for="item in endTimeList" :key="item.value" :label="item.label"
                                            :value="item.value" :disabled="item.disabled" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="价格类别" prop="priceType" style="width: calc(33% - 40px)">
                                    <el-select v-model="item.priceType" placeholder="请选择价格类别" style="width: 100%">
                                        <el-option v-for="item in priceTypeArray" :key="item.value" :label="item.label"
                                            :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-row>
                        <el-row v-if="isEnd" style="
                display: flex;
                margin-left: 130px;
                width: calc(100% - 130px);
              ">
                            <el-input placeholder="剩余时间价格统一选择" disabled style="width: 72%; margin-right: 3%" />
                            <el-select v-model="editForm.end" placeholder="请选择价格类别" disabled="true" style="width: 25%">
                                <el-option v-for="item in priceTypeArray" :key="item.value" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                        </el-row>
                    </div>
                </div>
                <el-form-item label="运营状态" prop="operatorStatus" style="width: 600px">
                    <el-select v-model="editForm.operatorStatus" placeholder="请选择运营状态" style="width: 100%">
                        <el-option label="新建" :value="0" />
                        <el-option label="运营中" :value="1" />
                        <el-option label="暂停运营" :value="2" />
                    </el-select>
                </el-form-item>
            </el-form>
        </el-card>

        <el-card shadow="never">
            <div slot="header">
                <span class="title">硬件信息</span>
            </div>
            <el-form ref="thirdForm" :model="thirdForm" :rules="thirdRules" label-width="120px">
                <div style="width: 600px">
                    <el-form-item label="电桩国标" prop="equipmentInternational">
                        <el-radio-group v-model="thirdForm.equipmentInternational" style="width: 100%">
                            <el-radio :label="1">2011</el-radio>
                            <el-radio :label="2">2015</el-radio>
                            <el-radio :label="3">兼容2011和2015</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="充电模块品牌型号" prop="chargingModuleBrandId">
                        <el-select v-model="thirdForm.chargingModuleBrandId" filterable remote reserve-keyword
                            style="width: 100%" placeholder="请输入搜索关键词" :remote-method="selectChargeModule">
                            <el-option v-for="item in chargeModuleList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="充电枪线品牌型号" prop="chargingGunBrandId">
                        <el-select v-model="thirdForm.chargingGunBrandId" filterable remote reserve-keyword
                            style="width: 100%" placeholder="请输入搜索关键词" :remote-method="selectChargeGun">
                            <el-option v-for="item in chargeGunList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电桩屏幕品牌" prop="equipmentScreenBrandId">
                        <el-select v-model="thirdForm.equipmentScreenBrandId" filterable remote style="width: 100%"
                            reserve-keyword placeholder="请输入搜索关键词" :remote-method="selectEquipmentScreen">
                            <el-option v-for="item in equipmentScreenList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电桩程序" prop="equipmentProgram">
                        <el-input v-model="thirdForm.equipmentProgram" placeholder="请输入电桩程序" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="设备生产日期" prop="productionDate">
                        <el-date-picker v-model="thirdForm.productionDate" type="date" style="width: 100%"
                            value-format="yyyy-MM-dd" placeholder="请选择设备生产日期" :picker-options="pickerOptions" />
                    </el-form-item>
                </div>
                <el-row :gutter="12">
                    <el-col :span="8">
                        <el-form-item label="是否支持功率分摊" prop="apportionFlag">
                            <el-radio-group v-model="editForm.apportionFlag">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="分摊功率" prop="apportionPower">
                            <el-input-number :controls="false" v-model="editForm.apportionPower"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="恒功率电流下限" prop="constantCurrentLowerLimits">
                            <el-input-number :controls="false"
                                v-model="editForm.constantCurrentLowerLimits"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="恒功率电流上限" prop="constantCurrentUpperLimits">
                            <el-input-number :controls="false"
                                v-model="editForm.constantCurrentUpperLimits"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="恒功率电压下限" prop="constantVoltageLowerLimits">
                            <el-input-number :controls="false"
                                v-model="editForm.constantVoltageLowerLimits"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="恒功率电压上限" prop="constantVoltageUpperLimits">
                            <el-input-number :controls="false"
                                v-model="editForm.constantVoltageUpperLimits"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="运营状态" prop="opreateStatus">
                            <el-radio-group v-model="editForm.opreateStatus">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="50">运营中</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="辅源" prop="auxPower">
                            <el-radio-group v-model="editForm.auxPower">
                                <el-radio :label="1">12v</el-radio>
                                <el-radio :label="2">24v</el-radio>
                                <el-radio :label="3">12v与24v</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <el-card shadow="never">
            <div slot="header">
                <span class="title">保险及售后信息</span>
            </div>
            <el-form ref="lastForm" :model="lastForm" label-width="120px">
                <div style="width: 600px">
                    <el-form-item label="整机质保时间" prop="warrantyTime">
                        <el-select v-model="lastForm.warrantyTime" placeholder="请选择整机质保时间" style="width: 100%">
                            <el-option v-for="item in yearList" :key="item.label" :label="item.label"
                                :value="item.label" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模块质保时间" prop="moduleWarrantyTime">
                        <el-select v-model="lastForm.moduleWarrantyTime" placeholder="请选择模块质保时间" style="width: 100%">
                            <el-option v-for="item in yearList" :key="item.label" :label="item.label"
                                :value="item.label" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="保险品牌" prop="insuranceBrand">
                        <el-input v-model="lastForm.insuranceBrand" placeholder="请输入保险品牌" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="保险到期时间" prop="insuranceOverdueTime">
                        <el-date-picker v-model="lastForm.insuranceOverdueTime" type="date" style="width: 100%"
                            value-format="yyyy-MM-dd" placeholder="选择日期" />
                    </el-form-item>
                    <el-form-item label="保险单号" prop="insuranceId">
                        <el-input v-model="lastForm.insuranceId" placeholder="请输入保险单号" />
                    </el-form-item>
                    <el-form-item label="保单图片">
                        <el-upload class="avatar-uploader" style="width: 100%" :action="action" :headers="headers"
                            :show-file-list="false" :on-success="handleAvatarSuccess" :on-remove="handleRemove"
                            :before-upload="beforeAvatarUpload" accept="image/png,image/jpg,image/jpeg">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                            <span v-if="imageUrl" class="el-upload-action" @click.stop="handleRemove()">
                                <i class="el-icon-delete" />
                            </span>
                            <i v-else class="el-icon-plus avatar-uploader-icon" />
                        </el-upload>
                        <div style="font-size: 13px; line-height: 20px; color: #409eff">
                            温馨提示：只能上传jpg/jpeg/png文件，且不超过2M
                        </div>
                    </el-form-item>
                </div>

                <el-form-item style="display: flex; flex-direction: column; text-align: center">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="onSubmit(true)">保存</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { HOST, EV_HOST } from "@/utils/host";
import { regionData } from "element-china-area-data";
import times from "./data.json";
export default {
    name: "Xiugaichongdianqiang",
    components: {},
    data() {
        var checkNumber = (rule, value, cb) => {
            if (value < 0) {
                cb(new Error("请输入非负数的费用金额"));
            } else {
                return cb();
            }
        };
        return {
            canAdd: false, // 是否可继续增加价格设置
            deffprops: {
                label: "name",
                value: "id",
                checkStrictly: true,
            },
            number: "",
            firstForm: {
                connectorName: "",
                connectorCode: "",
            },
            firstRules: {
                connectorName: [
                    {
                        required: true,
                        message: "请输入终端名称",
                        trigger: "change",
                    },
                ],
                connectorCode: [
                    {
                        required: true,
                        message: "请输入终端编码",
                        trigger: "blur",
                    },
                ],
            },

            secondForm: {
                equipmentCode: "",
                agreementVersion: "",
                equipmentName: "",
                communicationType: "",
                communicationOperator: "",
                hasSIM: true,
                SIMNum: "",
                parkNo: "",
                parkLock: false,
            },
            secondRules: {
                equipmentCode: [
                    {
                        required: true,
                        message: "请输入电桩编码",
                        trigger: "blur",
                    },
                ],
                agreementVersion: [
                    {
                        required: true,
                        message: "请选择协议版本",
                        trigger: "change",
                    },
                ],
                equipmentName: [
                    {
                        required: true,
                        message: "请输入电桩名称",
                        trigger: "blur",
                    },
                ],
                communicationType: [
                    {
                        required: true,
                        message: "请选择通讯模块",
                        trigger: "change",
                    },
                ],
                communicationOperator: [
                    {
                        required: true,
                        message: "请选择通讯运营商",
                        trigger: "change",
                    },
                ],
                hasSIM: [
                    {
                        required: true,
                        message: "请选择有无SIM",
                        trigger: "change",
                    },
                ],
                // parkNo: [{ required: true, message: "请输入车位号", trigger: "blur" }],
                // parkLock: [
                //   { required: true, message: "请选择有无地锁", trigger: "change" },
                // ],
            },
            imageUrl: "",
            editForm: {
                calculateMode: [],
                types: [
                    {
                        name: "",
                        elecMoney: "",
                        serviceMoney: "",
                        priceType: 1,
                    },
                ],
                ranges: [],
                end: 1,
                planLocation: 0,
                operatorStatus: "",
                apportionFlag: 1,
                apportionPower: 0,
                constantCurrentLowerLimits: 0,
                constantCurrentUpperLimits: 0,
                constantVoltageLowerLimits: 0,
                constantVoltageUpperLimits: 0,
                opreateStatus: 1,
                auxPower: 3,
            },
            editFormRules: {
                planLocation: [
                    {
                        required: true,
                        message: "请选择价格设置",
                    },
                ],
                operatorStatus: [
                    {
                        required: true,
                        message: "请选择运营状态",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "请输入价格类别名称",
                        trigger: "blur",
                    },
                ],
                calculateMode: [
                    {
                        required: true,
                        message: "请选择支持计费模式",
                        trigger: "change",
                    },
                ],
                elecMoney: [
                    {
                        required: true,
                        message: "请输入电费额度",
                        trigger: "blur",
                    },
                    {
                        validator: checkNumber,
                        trigger: "blur",
                    },
                ],
                serviceMoney: [
                    {
                        required: true,
                        message: "请输入服务费额度",
                        trigger: "blur",
                    },
                    {
                        validator: checkNumber,
                        trigger: "blur",
                    },
                ],
                priceStartPeriod: [
                    {
                        required: true,
                        message: "请选择开始时间",
                        trigger: "change",
                    },
                ],
                priceEndPeriod: [
                    {
                        required: true,
                        message: "请选择结束时间",
                        trigger: "change",
                    },
                ],
                priceType: [
                    {
                        required: true,
                        message: "请选择价格类别",
                        trigger: "change",
                    },
                ],
            },
            thirdForm: {
                equipmentInternational: 0,
                chargingGunBrandId: "",
                chargingModuleBrandId: "",
                equipmentScreenBrandId: "",
                equipmentProgram: "",
                productionDate: "",
            },
            thirdRules: {
                productionDate: [
                    {
                        required: true,
                        message: "请选择生产日期",
                        trigger: "change",
                    },
                ],
            },
            lastForm: {
                warrantyTime: "",
                moduleWarrantyTime: "",
                insuranceBrand: "",
                insuranceOverdueTime: "",
                insuranceId: "",
                insurancePic: "",
            },
            priceTypeArray: [],
            isClick: false,
            startValue: "",
            endValue: "",
            stationId: "",
            chargeGunList: [],
            chargeModuleList: [],
            equipmentScreenList: [],
            isPrice: false,
            plantId: "",
            isEnd: false,
            station: "",
            equipmentBrandId: "",
            connectorId: "",
            equipmentId: "",
            token: window.localStorage.getItem("token"),
            isSIM: false,
            yearList: [
                {
                    label: "1年",
                },
                {
                    label: "2年",
                },
                {
                    label: "3年",
                },
                {
                    label: "4年",
                },
                {
                    label: "5年",
                },
                {
                    label: "6年",
                },
                {
                    label: "7年",
                },
                {
                    label: "8年",
                },
                {
                    label: "9年",
                },
                {
                    label: "10年",
                },
            ],
            startTimeList: [], // 开始时间集合
            endTimeList: [], // 结束时间集合
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6;
                },
            },
        };
    },
    computed: {
        headers() {
            return {
                token: window.localStorage.getItem("token"),
            };
        },
        action() {
            return HOST + "/oss";
        },
    },

    mounted() {
        this.startTimeList = this.timeInit(1);
        this.endTimeList = this.timeInit(0);
        this.selectChargeGun();
        this.selectChargeModule();
        this.selectEquipmentScreen();
        this.getDataDetail();
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() {
        this.connectorId = this.$route.query.data;
    }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { },
    methods: {
        async onSubmit(flag) {
            try {
                // 必填校验
                await Promise.all([
                    this.$refs.firstForm.validate(),
                    this.$refs.secondForm.validate(),
                    this.$refs.editForm.validate(),
                    this.$refs.thirdForm.validate(),
                ]);
            } catch (error) {
                return;
            }

            if (!flag) {
                this.$router.go(-1);
                return;
            }

            const newRanges = [];
            for (let i = 0; i < this.editForm.ranges.length; i++) {
                for (let j = 0; j < this.editForm.types.length; j++) {
                    if (this.editForm.ranges[i].priceType === j + 1) {
                        newRanges.push({
                            priceStartPeriod: this.editForm.ranges[i].priceStartPeriod,
                            priceEndPeriod: this.editForm.ranges[i].priceEndPeriod,
                            priceType: this.editForm.ranges[i].priceType,
                            defaultRange: this.editForm.ranges[i].defaultRange,
                            cpoElecMoney:
                                this.editForm.types[this.editForm.ranges[i].priceType - 1]
                                    .elecMoney,
                            cpoServiceMoney:
                                this.editForm.types[this.editForm.ranges[i].priceType - 1]
                                    .serviceMoney,
                        });
                    }
                }
            }
            console.log("newRanges", newRanges, 1111);

            newRanges.push({
                priceStartPeriod: 0,
                priceEndPeriod: 0,
                priceType: this.editForm.end,
                defaultRange: true,
                cpoElecMoney: this.editForm.types[this.editForm.end - 1].elecMoney,
                cpoServiceMoney:
                    this.editForm.types[this.editForm.end - 1].serviceMoney,
            });

            console.log(this.equipmentBrandId);

            this.form = {
                equipmentId: this.equipmentId,
                connectorId: this.connectorId,
                connectorName: this.firstForm.connectorName,
                connectorCode: this.firstForm.connectorCode,
                equipmentCode: this.secondForm.equipmentCode,
                agreementVersion: this.secondForm.agreementVersion,
                equipmentName: this.secondForm.connectorName,
                communicationType: this.secondForm.communicationType,
                communicationOperator: this.secondForm.communicationOperator,
                hasSIM: this.secondForm.hasSIM,
                SIMNum: this.secondForm.SIMNum,
                parkNo: this.secondForm.parkNo,
                parkLock: this.secondForm.parkLock,
                operatorStatus: this.editForm.operatorStatus,
                equipmentInternational: this.thirdForm.equipmentInternational,
                chargingModuleBrandId: this.thirdForm.chargingModuleBrandId,
                chargingGunBrandId: this.thirdForm.chargingGunBrandId,
                equipmentScreenBrandId: this.thirdForm.equipmentScreenBrandId,
                equipmentProgram: this.thirdForm.equipmentProgram,
                productionDate: this.thirdForm.productionDate,
                warrantyTime: this.lastForm.warrantyTime,
                moduleWarrantyTime: this.lastForm.moduleWarrantyTime,
                insuranceBrand: this.lastForm.insuranceBrand,
                insuranceOverdueTime: this.lastForm.insuranceOverdueTime,
                insuranceId: this.lastForm.insuranceId,
                insurancePic: this.lastForm.insurancePic,
                pricingModel: this.editForm.planLocation,
                apportionFlag: this.editForm.apportionFlag,
                apportionPower: this.editForm.apportionPower,
                constantCurrentLowerLimits: this.editForm.constantCurrentLowerLimits,
                constantCurrentUpperLimits: this.editForm.constantCurrentUpperLimits,
                constantVoltageLowerLimits: this.editForm.constantVoltageLowerLimits,
                constantVoltageUpperLimits: this.editForm.constantVoltageUpperLimits,
                opreateStatus: this.editForm.opreateStatus,
                auxPower: this.editForm.auxPower,
            };

            console.log("this.form", this.form);

            const data = this.form;
            if (this.isPrice) {
                data.types = this.editForm.types;
                data.ranges = newRanges;
            }
            this.$store.dispatch("form/handle", {
                url: "/station/equipment",
                data: data,
                method: "post",
                callback: (resp) => {
                    console.log("resp", resp);
                    this.$router.go(-1);
                    this.$notify({
                        title: "成功",
                        message: "修改成功",
                        type: "success",
                    });
                    // this.$store.dispatch("login/getCur");
                },
            });
        },
        cancel() {
            this.$router.go(-1);
        },

        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
            this.lastForm.insurancePic = res.data.fileName;
        },
        handleRemove() {
            this.imageUrl = "";
            this.lastForm.insurancePic = "";
        },
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/png" ||
                file.type === "image/jpg" ||
                file.type === "image/jpeg";
            const isLt2M = file.size <= 2097152;

            if (!isJPG) {
                this.$message.error("上传图片只能是 JPG/JEPG/PNG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },

        isShowMapClick() { },

        // 添加列
        addRow() {
            // 深拷贝对象
            const newStart = JSON.parse(JSON.stringify(times.timeList));
            const newEnd = JSON.parse(JSON.stringify(times.timeList));

            for (let i = 0; i < newStart.length; i++) {
                if (newStart[i].value === 49) {
                    newStart[i].disabled = true;
                }
            }

            for (let i = 0; i < newEnd.length; i++) {
                if (newEnd[i].value === 1) {
                    newEnd[i].disabled = true;
                }
            }

            if (this.editForm.ranges.length < 1) {
                this.editForm.ranges.push({
                    cpoElecMoney: 0,
                    cpoServiceMoney: 0,
                    priceStartPeriod: "",
                    priceEndPeriod: "",
                    priceType: 1,
                    defaultRange: false,
                    startTimeList: newStart,
                    endTimeList: newEnd,
                });

                this.isEnd = true;
            }
            if (this.editForm.types.length > 3) {
                return;
            } else if (
                this.editForm.types[this.editForm.types.length - 1].name === "" ||
                this.editForm.types[this.editForm.types.length - 1].elecMoney === 0 ||
                this.editForm.types[this.editForm.types.length - 1].serviceMoney === 0
            ) {
                this.$refs.editForm.validate();
                return;
            } else {
                this.editForm.types.push({
                    name: "",
                    elecMoney: "",
                    serviceMoney: "",
                    priceType: this.editForm.types.length + 1,
                });
            }
            console.log("this.editForm.types", this.editForm.types);
        },

        // 删除属性列
        removeRow(index) {
            let newval = "";
            if (this.priceTypeArray[index]) {
                newval = this.priceTypeArray[index].value;
                this.priceTypeArray.splice(index, 1);
            }
            this.editForm.types.splice(index, 1);
            if (this.editForm.types.length < 2) {
                this.editForm.ranges = [];
            } else {
                const haveType = [];
                for (let j = 0; j < this.priceTypeArray.length; j++) {
                    haveType.push(this.priceTypeArray[j].value);
                }
                for (let i = 0; i < this.editForm.ranges.length; i++) {
                    if (!haveType.includes(this.editForm.ranges[i].priceType)) {
                        this.editForm.ranges[i].priceType = "";
                    }
                }
            }
            if (newval && this.editForm.end == newval) {
                this.editForm.end = this.priceTypeArray[0].value;
            }
        },

        // 添加列
        addPriceTypeRow() {
            if (this.editForm.ranges.length >= 1) {
                if (
                    this.editForm.ranges[this.editForm.ranges.length - 1]
                        .priceStartPeriod === "" ||
                    this.editForm.ranges[this.editForm.ranges.length - 1]
                        .priceEndPeriod === ""
                ) {
                    this.$refs.editForm.validate();
                } else {
                    this.editForm.ranges.push({
                        cpoElecMoney: 0,
                        cpoServiceMoney: 0,
                        priceStartPeriod: "",
                        priceEndPeriod: "",
                        priceType: 1,
                        defaultRange: false,
                        startTimeList: [].concat(
                            JSON.parse(JSON.stringify(times.timeList))
                        ),
                        endTimeList: [].concat(JSON.parse(JSON.stringify(times.timeList))),
                    });
                    if (this.editForm.ranges.length === 48) {
                        this.isEnd = false;
                    }
                    this.editForm.ranges[
                        this.editForm.ranges.length - 1
                    ].startTimeList.map((ele) => {
                        this.editForm.ranges.map((val) => {
                            if (
                                Number(ele.value) >= Number(val.priceStartPeriod) &&
                                Number(ele.value) < Number(val.priceEndPeriod)
                            ) {
                                ele.disabled = true;
                            }
                        });
                    });
                    const bbb =
                        this.editForm.ranges[this.editForm.ranges.length - 1].startTimeList;
                    this.editForm.ranges.map((ele) => {
                        for (let i = 0; i < bbb.length; i++) {
                            if (ele.priceStartPeriod === 0 && bbb[i].value === 0) {
                                bbb[i].disabled = true;
                            }
                            if (i !== 0) {
                                if (
                                    bbb[i].disabled === false &&
                                    bbb[i - 1].disabled === true &&
                                    bbb[i + 1].disabled === true
                                ) {
                                    bbb[i].disabled = true;
                                }
                            }
                        }
                    });
                    this.editForm.ranges[this.editForm.ranges.length - 1].endTimeList =
                        JSON.parse(
                            JSON.stringify(
                                this.editForm.ranges[this.editForm.ranges.length - 1]
                                    .startTimeList
                            )
                        );
                    this.editForm.ranges[
                        this.editForm.ranges.length - 1
                    ].endTimeList[0].disabled = true;
                    this.editForm.ranges[
                        this.editForm.ranges.length - 1
                    ].startTimeList[48].disabled = true;
                }
            }
        },
        removePriceTypeRow(index) {
            this.editForm.ranges.splice(index, 1);
            this.canAdd = false;
            this.isEnd = true;
        },

        // 添加价格类别
        addPriceTypeClick() {
            console.log("this.editForm.info2", this.editForm.types);
            this.priceTypeArray = [];
            for (let i = 0; i < this.editForm.types.length; i++) {
                const type =
                    this.editForm.types[i].name +
                    "：" +
                    "电费" +
                    "【" +
                    this.editForm.types[i].elecMoney +
                    "元" +
                    "】" +
                    "服务费" +
                    "【" +
                    this.getFloat(this.editForm.types[i].serviceMoney) +
                    "元" +
                    "】";
                this.priceTypeArray.push({
                    value: i + 1,
                    label: type,
                });
            }
            console.log("this.priceTypeArray", this.priceTypeArray);
        },
        startShowClick(e, item, index) { },
        endShowClick(e, item, index) { },
        canAddBtn(val) {
            console.log(val, "val");
            if (val === 49) {
                this.canAdd = true;
            } else {
                this.canAdd = false;
            }
        },

        // 选择开始时间
        selectedStartTime(item, index) {
            if (item.priceStartPeriod === 0) {
                this.editForm.ranges.map((ele) => {
                    ele.startTimeList[0].disabled = true;
                });
            }
            if (this.editForm.ranges.length > 1) {
                item.endTimeList.map((ele) => {
                    if (Number(ele.value) <= Number(item.priceStartPeriod)) {
                        ele.disabled = true;
                    }
                    const aa = this.editForm.ranges.map((val) => {
                        if (Number(val.priceStartPeriod) > Number(item.priceStartPeriod)) {
                            return val.priceStartPeriod;
                        }
                    });
                    if (Number(ele.value) > Number(aa[0])) {
                        ele.disabled = true;
                    }
                    if (Number(ele.value) === Number(aa[0])) {
                        ele.disabled = false;
                    }
                });
            } else {
                item.endTimeList.map((ele) => {
                    if (Number(ele.value) <= Number(item.priceStartPeriod)) {
                        ele.disabled = true;
                    }
                });
            }
        },

        // 选择结束时间
        selectedEndTime(item, index) {
            item.startTimeList.map((ele) => {
                if (Number(ele.value) >= Number(item.priceEndPeriod)) {
                    ele.disabled = true;
                }
            });
            const that = this;
            this.editForm.ranges.forEach((el, em) => {
                if (
                    el.priceStartPeriod === item.priceStartPeriod &&
                    el.priceEndPeriod === item.priceEndPeriod &&
                    em === that.editForm.ranges.length - 1
                ) {
                    this.editForm.ranges.map((el) => {
                        if (
                            el.priceStartPeriod !== item.priceStartPeriod &&
                            el.priceEndPeriod !== item.priceEndPeriod
                        ) {
                            el.endTimeList.map((em) => {
                                if (Number(em.value) > Number(item.priceStartPeriod)) {
                                    em.disabled = true;
                                }
                            });
                        }
                    });
                }
            });
        },
        selectFocusTime(type, index, item) {
            if (type === 1) {
                // 选择开始时间
                for (let i = 0; i < 48; i++) {
                    this.startTimeList[i].disabled = false;
                }
                if (item.priceEndPeriod) {
                    // 当前区间有结束时间时，结束时间之后的开始时间选项置灰
                    for (let i = item.priceEndPeriod - 1; i < 48; i++) {
                        this.startTimeList[i].disabled = true;
                    }
                }
                for (let i = 0; i < this.editForm.ranges.length; i++) {
                    const tmp = this.editForm.ranges[i];
                    if (i !== index) {
                        // 非当前时间区间
                        if (
                            item.priceEndPeriod &&
                            item.priceEndPeriod > tmp.priceEndPeriod
                        ) {
                            // 如有当前结束时间且当前结束时间>已选结束时间，已选结束时间之前置灰
                            for (let j = 0; j < tmp.priceEndPeriod - 1; j++) {
                                this.startTimeList[j].disabled = true;
                            }
                        } else {
                            // 将已选时间区间的时间选项置灰
                            for (
                                let j = tmp.priceStartPeriod - 1;
                                j < tmp.priceEndPeriod - 1;
                                j++
                            ) {
                                this.startTimeList[j].disabled = true;
                            }
                        }
                    }
                }
            } else {
                // 选择结束时间
                for (let i = 1; i < 49; i++) {
                    this.endTimeList[i].disabled = false;
                }
                if (item.priceStartPeriod) {
                    // 当前区间有开始时间时，开始时间之前的开始时间选项置灰
                    for (let i = 1; i < item.priceStartPeriod; i++) {
                        this.endTimeList[i].disabled = true;
                    }
                }
                for (let i = 0; i < this.editForm.ranges.length; i++) {
                    const tmp = this.editForm.ranges[i];
                    if (i !== index) {
                        // 非当前时间区间
                        if (
                            item.priceStartPeriod &&
                            item.priceStartPeriod < tmp.priceStartPeriod
                        ) {
                            // 如果当前开始时间且当前开始时间<已选当前时间，已选当前时间之后的选项置灰
                            for (let j = tmp.priceStartPeriod; j < 49; j++) {
                                this.endTimeList[j].disabled = true;
                            }
                        } else {
                            // 将已选时间区间的时间选项置灰
                            for (let j = tmp.priceStartPeriod; j < tmp.priceEndPeriod; j++) {
                                this.endTimeList[j].disabled = true;
                            }
                        }
                    }
                }
            }
        },
        getTreeData(data) {
            if (!data) {
                return [];
            }
            for (var i = 0; i < data.length; i++) {
                if (!data[i].children) {
                    return data;
                }
                if (data[i].children.length === 0) {
                    // children若为空数组，则将children设为undefined
                    delete data[i].children;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].children);
                }
            }
            return data;
        },

        companytree(val) {
            console.log(
                "companie",
                this.$refs.brandTree.getCheckedNodes()[0].data.attrs.number
            );
            this.number = this.$refs.brandTree.getCheckedNodes()[0].data.attrs.number;
            console.log("ccccc", val);
            this.plantId = val[val.length - 1];
        },

        isHasSIM(val) {
            console.log(val);
            if (val) {
                this.isSIM = true;
            } else {
                this.isSIM = false;
                this.secondForm.SIMNum = "";
            }
        },

        selectplanLocation(val) {
            if (val === 0) {
                this.isPrice = false;
            } else if (val === 1) {
                this.isPrice = true;
                this.queryFeeAndRanges();
            }
        },

        queryFeeAndRanges() {
            const data = {
                stationId: this.stationId,
                equipmentId: this.equipmentId,
            };
            this.$store.dispatch("form/handle", {
                url: "/station/equipment/getFeeAndRange",
                method: "get",
                data: data,
                callback: (resp) => {
                    if (resp.types && resp.types.length > 0) {
                        if (!this.editForm.calculateMode.includes("1")) {
                            this.editForm.calculateMode.push("1");
                        }
                        resp.types.forEach((element) => {
                            element.serviceMoney = this.getFloat(element.serviceMoney);
                            element.elecMoney = this.getFloat(element.elecMoney);
                        });
                        this.editForm.types = resp.types;
                    } else {
                        this.editForm.types = resp.types;
                    }
                    if (resp.ranges && resp.ranges.length > 0) {
                        resp.ranges.forEach((element, index) => {
                            if (
                                element.priceStartPeriod === 0 &&
                                element.priceEndPeriod === 0
                            ) {
                                this.editForm.end = element.priceType;
                                resp.ranges.splice(index, 1);
                                this.isEnd = true;
                            }
                        });
                        this.editForm.ranges = resp.ranges;
                    } else {
                        this.editForm.ranges = resp.ranges;
                    }
                    this.addPriceTypeClick();
                },
            });
        },

        selectChargeGun(val) {
            const data = {
                name: val,
            };
            this.$store.dispatch("form/handle", {
                url: "/station/equipment/getChargeGunByName",
                method: "get",
                data: data,
                callback: (resp) => {
                    console.log("resp1", resp);
                    this.chargeGunList = resp;
                },
            });
        },

        selectChargeModule(val) {
            const data = {
                name: val,
            };
            this.$store.dispatch("form/handle", {
                url: "/station/equipment/getChargeModuleByName",
                method: "get",
                data: data,
                callback: (resp) => {
                    console.log("resp2", resp);
                    this.chargeModuleList = resp;
                },
            });
        },

        selectEquipmentScreen(val) {
            const data = {
                name: val,
            };
            this.$store.dispatch("form/handle", {
                url: "/station/equipment/getEquipmentScreenByName",
                method: "get",
                data: data,
                callback: (resp) => {
                    console.log("resp3", resp);
                    this.equipmentScreenList = resp;
                },
            });
        },

        changeElecMoney(val) {
            console.log("lecMoney", val);
            this.editForm.types.map((res) => {
                if (res.elecMoney === val) {
                    res.elecMoney = this.getFloat(res.elecMoney);
                }
            });
        },

        changeServiceMoney(val) {
            console.log("ServiceMoney", val);
            this.editForm.types.map((res) => {
                if (res.serviceMoney === val) {
                    res.serviceMoney = this.getFloat(res.serviceMoney);
                }
            });
        },
        timeInit(type) {
            const timeBlock = [];
            for (let i = 0; i < 49; i++) {
                let a = 1;
                let b = 0;
                let label = "";
                let value = 0;
                let temp = {};
                a = Math.floor(i / 2);
                a = a > 9 ? a.toString() : `0${a}`;
                b = (i % 2) * 30;
                b = b === 30 ? b.toString() : `${b}0`;

                label = `${a}:${b}`;
                value = i;

                if (type === 0) {
                    temp = {
                        label,
                        value: value + 1,
                        disabled: i === 0,
                    };
                } else {
                    temp = {
                        label,
                        value: value + 1,
                        disabled: i === 48,
                    };
                }
                timeBlock[i.toString()] = temp;
            }
            return timeBlock;
        },
        getDataDetail() {
            if (this.connectorId) {
                const data = {
                    connectorId: this.connectorId,
                };
                this.$store.dispatch("form/handle", {
                    url: "/station/equipment/getDataDetail",
                    data: data,
                    method: "get",
                    callback: (resp) => {
                        console.log("resp", resp);
                        this.equipmentId = resp.equipmentId;
                        this.station = resp.stationName;
                        this.equipmentBrandId = resp.equipBrandName;
                        this.number = resp.number;
                        this.firstForm.connectorName = resp.connectorName;
                        this.firstForm.connectorCode = resp.connectorCode;
                        this.secondForm.equipmentCode = resp.equipmentCode;
                        this.secondForm.agreementVersion = resp.agreementVersion;
                        this.secondForm.equipmentName = resp.equipmentName;
                        this.secondForm.communicationType = resp.communicationType;
                        this.secondForm.communicationOperator = resp.communicationOperator;
                        this.secondForm.hasSIM = resp.hasSIM;
                        this.secondForm.parkNo = resp.parkNo;
                        this.secondForm.parkLock = resp.parkLock;
                        this.editForm.operatorStatus = resp.operatorStatus;
                        this.editForm.apportionFlag = resp.apportionFlag;
                        this.editForm.apportionPower = resp.apportionPower;
                        this.editForm.constantCurrentLowerLimits =
                            resp.constantCurrentLowerLimits;
                        this.editForm.constantCurrentUpperLimits =
                            resp.constantCurrentUpperLimits;
                        this.editForm.constantVoltageLowerLimits =
                            resp.constantVoltageLowerLimits;
                        this.editForm.constantVoltageUpperLimits =
                            resp.constantVoltageUpperLimits;
                        this.editForm.opreateStatus = resp.opreateStatus;
                        this.editForm.auxPower = resp.auxPower;
                        this.thirdForm.equipmentInternational = resp.equipmentInternational;
                        this.thirdForm.chargingGunBrandId = resp.chargingGunBrandId;
                        this.thirdForm.chargingModuleBrandId = resp.chargingModuleBrandId;
                        this.thirdForm.equipmentScreenBrandId = resp.equipmentScreenBrandId;
                        this.thirdForm.equipmentProgram = resp.equipmentProgram;
                        this.thirdForm.productionDate = resp.productionDate;
                        this.lastForm.warrantyTime = resp.warrantyTime;
                        this.lastForm.moduleWarrantyTime = resp.moduleWarrantyTime;
                        this.lastForm.insuranceBrand = resp.insuranceBrand;
                        this.lastForm.insuranceOverdueTime = resp.insuranceOverdueTime;
                        this.lastForm.insuranceId = resp.insuranceId;
                        this.lastForm.insurancePic = resp.insurancePic;

                        if (resp.hasSIM) {
                            this.isSIM = true;
                            this.secondForm.SIMNum = resp.SIMNum;
                        } else {
                            this.isSIM = false;
                            this.secondForm.SIMNum = "";
                        }

                        this.imageUrl =
                            HOST +
                            "/oss?objectName=" +
                            resp.insurancePic +
                            "&token=" +
                            this.token;
                        this.stationId = resp.stationId;
                        console.log(resp.pricingModel, "model");
                        this.editForm.planLocation = resp.pricingModel;
                        if (resp.pricingModel === 1) {
                            this.isPrice = true;
                            if (
                                resp.equipFeeTypes === undefined ||
                                resp.equipFeeTypes === null ||
                                resp.equipFeeTypes.length === 0
                            ) {
                                this.editForm.types = [];
                            } else {
                                resp.equipFeeTypes.forEach((element) => {
                                    element.serviceMoney = this.getFloat(element.serviceMoney);
                                    element.elecMoney = this.getFloat(element.elecMoney);
                                });
                                this.editForm.types = resp.equipFeeTypes;
                            }
                            if (
                                resp.equipFeeRanges === undefined ||
                                resp.equipFeeRanges === null ||
                                resp.equipFeeRanges.length === 0
                            ) {
                                this.editForm.ranges = [];
                            } else {
                                resp.equipFeeRanges.forEach((element, index) => {
                                    if (
                                        element.priceStartPeriod === 0 &&
                                        element.priceEndPeriod === 0
                                    ) {
                                        this.editForm.end = element.priceType;
                                        resp.equipFeeRanges.splice(index, 1);
                                        this.isEnd = true;
                                    }
                                });
                                this.editForm.ranges = resp.equipFeeRanges;
                            }
                            this.addPriceTypeClick();
                        }
                    },
                });
            }
        },
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" scoped>
.avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}

.avatar {
    width: 120px;
    height: 120px;
    display: block;
}

#container {
    width: 500px;
    height: 400px;
}

.el-upload-action {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    font-size: 0;
    color: #fff;
    text-align: center;
    line-height: 120px;
}

.el-upload-action:hover {
    font-size: 20px;
    background-color: #000;
    background-color: rgba(0, 0, 0, 0.3);
}

.form-card {
    padding: 10px 20px;
    border: 1px solid #e0e0e0;
    margin-top: 20px;

    .el-icon-remove {
        color: #f78989;
        font-size: 24px;
        height: 40px;
        line-height: 40px;
    }

    .el-icon-circle-plus {
        color: #409eff;
        font-size: 24px;
        height: 40px;
        line-height: 40px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/chargingPile.vue